// src/pages/Workflows/Execucoes/hooks/useWorkflowExecucoes.js

import { useState, useCallback, useEffect } from 'react';
import axios from 'axios';

export function useWorkflowExecucoes(workflowId) {
  const [execucoes, setExecucoes] = useState([]);
  const [execucaoSelecionada, setExecucaoSelecionada] = useState(null);
  const [nosExecucao, setNosExecucao] = useState([]);
  const [loadingLista, setLoadingLista] = useState(true);
  const [loadingDetalhe, setLoadingDetalhe] = useState(false);
  const [error, setError] = useState('');
  const [workflowNome, setWorkflowNome] = useState('');
  const [workflowDefinicao, setWorkflowDefinicao] = useState({ nodes: [], edges: [] });

  const carregarLista = useCallback(async () => {
    if (!workflowId) return;
    try {
      setLoadingLista(true);
      const response = await axios.get(`/api/workflows/${workflowId}/execucoes`);
      if (response.data.success) {
        setExecucoes(response.data.data);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao carregar execuções');
    } finally {
      setLoadingLista(false);
    }
  }, [workflowId]);

  useEffect(() => {
    carregarLista();
  }, [carregarLista]);

  // Carregar dados do workflow (nome + definicao)
  useEffect(() => {
    if (!workflowId) return;
    axios.get(`/api/workflows/${workflowId}`)
      .then(r => {
        if (r.data.success) {
          setWorkflowNome(r.data.data.nome);
          setWorkflowDefinicao(r.data.data.definicao || { nodes: [], edges: [] });
        }
      })
      .catch(() => {});
  }, [workflowId]);

  const selecionarExecucao = useCallback(async (execucaoId) => {
    try {
      setLoadingDetalhe(true);
      const response = await axios.get(`/api/workflows/execucoes/${execucaoId}`);
      if (response.data.success) {
        setExecucaoSelecionada(response.data.data);
        setNosExecucao(response.data.data.nos || []);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao carregar execução');
    } finally {
      setLoadingDetalhe(false);
    }
  }, []);

  return {
    execucoes,
    execucaoSelecionada,
    nosExecucao,
    workflowNome,
    workflowDefinicao,
    loadingLista,
    loadingDetalhe,
    error,
    selecionarExecucao,
    carregarLista,
  };
}
